import styled from 'styled-components';
import Paper from '@mui/material/Paper';

export const GameBox = styled.div<{ width: number }>`
  border: 3px solid #808080;
  padding: 5px;
  background: #c0c0c0;
  width: ${props => props.width + 6}px;
  position: relative;
`;

export const WinBox = styled.div`
  position: absolute;
  top: 105px; bottom: 0;
  left: 0; right: 0;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  color: #fff;
`;

export const WinBoxInner = styled(Paper)`
  padding: 20px;
  font-size: 13px;
  border-radius: 4px;
`;